<script setup lang="ts">
import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { TextTertiary } from '@shared/ui/typography'
import { BtnCheckbox } from '@shared/ui/button'

defineOptions({
  name: 'CheckboxItem',
})

const props = withDefaults(defineProps<CheckboxItemProps>(), {
  checked: false,
  required: false,
  disabled: false,
  label: '',
  mode: 'normal',
})

const emit = defineEmits<{
  click: []
}>()

interface CheckboxItemProps {
  checked?: boolean
  required?: boolean
  disabled?: boolean
  label?: string
  mode?: InputMode
}

const handleClick = (): void => {
  if (!props.disabled) {
    emit('click')
  }
}
</script>

<template>
  <div
    class="checkbox-item"
    @click="handleClick"
  >
    <BtnCheckbox
      size="default"
      :checked="checked"
      :aria-label="label"
      :disabled="disabled"
      :mode="mode"
    />
    <TextTertiary>
      {{ label }}
      <span
        v-if="required"
        class="checkbox-item__required"
      >*</span>
    </TextTertiary>
  </div>
</template>

<style scoped lang="scss" src="./CheckboxItem.scss" />